// extracted by mini-css-extract-plugin
export default {"container":"Cl41X","content":"_22Nll"};